module.exports = __webpack_public_path__ + "static/img/lb2.a85017d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb2.png
// module id = qciN
// module chunks = 0